import { TaskError } from '../../errors/TaskError';
import { AbstractTask } from './AbstractTask';
import { UpdateFile } from './UpdateFile';
import { UploaderError } from '../../errors/UploaderError';
export class UpdateParts extends AbstractTask {
    constructor(context, file, parts) {
        super(context);
        this.sdkFatalErrors = [
            this.context.transferSdk.errors.UpdateTransferFilePartsError.InvalidParameterError,
            this.context.transferSdk.errors.UpdateTransferFilePartsError.FileAlreadyLockedError,
            this.context.transferSdk.errors.UpdateTransferFilePartsError.NotFoundError,
            this.context.transferSdk.errors.UpdateTransferFilePartsError.TransferAlreadyLockedError,
            this.context.transferSdk.errors.UpdateTransferFilePartsError.UnauthorizedError,
            this.context.transferSdk.errors.UpdateTransferFilePartsError.UnknownError,
        ];
        this.transfer = context.transfer;
        this.file = file;
        this.parts = parts;
        this.updateTransferFilePartsParameters = {
            transferId: this.transfer.id,
            fileId: this.file.id,
            parts: this.parts.map(part => ({ etag: part.etag, crc32: part.crc32, id: part.id })),
        };
    }
    preProcess(context) {
        return this;
    }
    process() {
        return new Promise(async (resolve) => {
            try {
                this.response = await this.context.transferSdk.updateTransferFileParts(this.updateTransferFilePartsParameters);
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.FileAlreadyLockedError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.TransferAlreadyLockedError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.ConnectionAbortedError) {
                    this.error = new TaskError(this, error);
                }
                else {
                    this.error = new TaskError(this, error);
                }
            }
            resolve(this);
        });
    }
    postProcess(context) {
        this.transfer.populateCompletedParts(this.file, this.parts, this.response);
        if (this.file.hasAllPartsUploaded()) {
            context.updateFileQueue.add(new UpdateFile(this.context, this.file));
        }
        return null;
    }
    processError() {
        if (this.error) {
            if (this.error.isInstanceOfOneOfTheseErrors(this.sdkFatalErrors)) {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            else if (this.error.getError() instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.UpdateTransferFilePartsError.ConnectionAbortedError) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else if (this.executionNumber < this.maxExecutionNumber) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            return this.error;
        }
        throw new Error('Method task.processError() should be called only if task.isOnError() === true');
    }
}
